import { z } from 'zod/v3';

export const warehousesListingSearchParamsSchema = z.object({
  query: z.coerce.string().optional(),
  addWarehouseModalOpen: z.boolean().optional(),
  editWarehouseId: z.string().optional(),
});

export type WarehousesListingSearchParamsSchemaType = z.infer<
  typeof warehousesListingSearchParamsSchema
>;
